import React from 'react';
import PropTypes from 'prop-types';

import {Stack, Typography, Box, Chip} from 'views/components';
import {Translate, translate} from 'views/module';

const LanguageView = (props) => {
  const {bioQuestions, setIsComplete} = props;

  const {
    languages = [],
  } = bioQuestions;

  React.useEffect(() => {
    const isComplete = languages.length > 0;
    setIsComplete(isComplete);
  }, [languages, setIsComplete]);

  if (!languages.length) {
    return (
      <Stack spacing={1.5} alignItems="flex-start">
        <Typography variant="body2" color="text.secondary">
          <Translate expression="caregiver.CaregiverBiography.Languages.EmptyState" />
        </Typography>
      </Stack>
    );
  }

  return (
    <Stack spacing={2} alignItems="flex-start">
      <Box display="flex" flexWrap="wrap">
        {
          languages.map((language) => {
            const predefinedLanguage = translate(`caregiver.CaregiverBiography.Languages.AvailableLanguages.${language.name}`);
            const languageLabel = predefinedLanguage !== 'Missing translation' ? predefinedLanguage : language.name;

            return (
              <Chip
                key={`${language.name}-${language.fluency}`}
                label={
                  <Typography
                    variant="body2"
                    sx={{color: '#0288d1', fontWeight: 500}}
                  >
                    {
                      `${languageLabel} : ${translate(`caregiver.CaregiverBiography.Languages.Fluency.${language.fluency}`)}`
                    }
                  </Typography>
                }
                sx={{
                  border: '1px solid #0288d1',
                  borderRadius: '16px',
                  backgroundColor: '#e1f5fe',
                  paddingY: '6px',
                  paddingX: '10px',
                  marginRight: '6px',
                  marginBottom: '6px',
                }}
              />
            );
          })
        }
      </Box>
    </Stack>
  );
};

LanguageView.propTypes = {
  bioQuestions: PropTypes.object.isRequired,
  setIsComplete: PropTypes.func.isRequired,
};

export default React.memo(LanguageView);
